<div class="dzf-root">
  <button type="button" class="dzf-trigger" [class.disabled]="disabled" [class.active]="isOpen || selectedCount > 0" (click)="toggleOpen()">
    <span [class.placeholder]="selectedCount === 0">{{ triggerLabel }}</span>
    <i class="fas fa-chevron-down text-gray-400 ml-auto text-xs"></i>
  </button>

  <div class="dzf-popup" *ngIf="isOpen">
    <div class="dzf-search">
      <i class="fas fa-search dzf-search-icon"></i>
      <input
        type="text"
        [(ngModel)]="searchQuery"
        placeholder="Search district or zone"
        class="dzf-search-input">
      <button type="button" class="dzf-clear-search" *ngIf="isSearching" (click)="clearSearch()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <label class="dzf-select-all-row">
      <input
        type="checkbox"
        [checked]="selectAllState === 'checked'"
        [indeterminate]="selectAllState === 'indeterminate'"
        (click)="toggleSelectAll()">
      <span>Select all ({{ filteredZoneCount }} filtered)</span>
    </label>

    <div class="dzf-list">
      <div class="dzf-empty" *ngIf="filteredGroups.length === 0">No districts or zones match your search.</div>

      <div class="dzf-group" *ngFor="let group of filteredGroups">
        <div class="dzf-group-header" (click)="toggleGroupExpanded(group)">
          <i
            class="fas dzf-chevron"
            [ngClass]="isGroupExpanded(group) ? 'fa-chevron-down' : 'fa-chevron-right'"
          ></i>
          <input
            type="checkbox"
            [checked]="groupSelectionState(group) === 'checked'"
            [indeterminate]="groupSelectionState(group) === 'indeterminate'"
            (click)="$event.stopPropagation(); toggleGroup(group)">
          <span class="dzf-group-name">{{ group.name }}</span>
          <span class="dzf-group-count">
            {{ selectedZoneCount(group) }}/{{ group.zones.length }}
          </span>
        </div>

        <ng-container *ngIf="isGroupExpanded(group)">
          <label class="dzf-zone-row" *ngFor="let zone of group.zones">
            <input
              type="checkbox"
              [checked]="isZoneSelected(zone.value)"
              (click)="toggleZone(zone.value)">
            <span>{{ zone.label }}</span>
          </label>
        </ng-container>
      </div>
    </div>
  </div>
</div>
